import noop from 'lodash/noop';

/*
  if shouldPerformAction function returns true then action performs otherwise not
*/

export function createActionByConditionFactory ({
  shouldPerformAction = () => true,
  beforeAction = noop,
  afterAction = noop,
  onError = noop,
}) {
  return (action) => (...args) => async (dispatch, getState) => {

    if (!shouldPerformAction(getState, ...args)) {
      return;
    }

    const nextParams = [dispatch, getState, ...args];

    beforeAction(...nextParams);

    try {
      const result = await dispatch(action(...args));

      afterAction(...nextParams);

      return result;

    } catch (e) {
      onError(...nextParams);

      Logger.error('Something went wrong in "actionByConditionFactory"', e);

      return Promise.reject(e);
    }
  };
}
